import { FC } from "react";
import { useTranslation } from "react-i18next";
import useEvent from "react-use-event-hook";

import { useModalConfirm } from "@ryde/redux";
import {
  capitalize,
  ConfirmResult,
  mergeTodayWithHHmmTime,
  TTimeHHmm,
  useFormats,
  useTimezone,
} from "@ryde/shared";

import { ColorIconButton } from "../../../controls";
import { CsvCellTemplate } from "../../templates-table";
import { IAvailabilityItemForm } from "./table-availability.models";

export const AvailabilityItemDisplay: FC<IAvailabilityItemForm> = ({
  removeHandler,
  index,
  onEdit,
  value,
  disabledEdit,
  disabledRemove,
}) => {
  const { t } = useTranslation();
  const { timezone } = useTimezone();
  const { confirmDialogResult } = useModalConfirm();
  const message = t(`general.ITEM_ARCHIVE_MESSAGE`);
  const { formatTimeNormalized } = useFormats();

  const onArchiveClickEvent = useEvent(async (): Promise<void> => {
    const confirmationResult = await confirmDialogResult({
      title: t("general.CONFIRM"),
      message,
    });

    if (confirmationResult === ConfirmResult.OK) {
      removeHandler?.(index || 0);
    }
  });
  return (
    <div className="availability-item display-mode">
      <div className="availability-item__data">
        {Boolean(value?.dayTypeIds?.length) && (
          <div className="availability-item__data--row">
            <label>{capitalize(t("dayType.plural"))}:</label>
            <CsvCellTemplate
              name={"dayTypeIds"}
              customClassName="availability-cell"
              value={value?.dayTypeIds}
              formAttributes={{ dropItemsSource: "dayType" }}
            />
          </div>
        )}
        {Boolean(value?.dayGroupIds?.length) && (
          <div className="availability-item__data--row">
            <label>{capitalize(t("dayType.plural"))}:</label>
            <CsvCellTemplate
              name={"dayGroupIds"}
              customClassName="availability-cell"
              value={value?.dayGroupIds}
              formAttributes={{ dropItemsSource: "dayGroup" }}
            />
          </div>
        )}
        {Boolean(value?.from) && (
          <div className="availability-item__data--row">
            <label>{t("general.FROM")}:</label>
            <div className="availability-cell">
              {formatTimeNormalized(
                mergeTodayWithHHmmTime(value?.from as TTimeHHmm, timezone),
              )}
            </div>
          </div>
        )}
        {Boolean(value?.to) && (
          <div className="availability-item__data--row">
            <label>{t("general.TO")}:</label>
            <div className="availability-cell">
              {formatTimeNormalized(
                mergeTodayWithHHmmTime(value?.to as TTimeHHmm, timezone),
              )}
            </div>
          </div>
        )}
      </div>
      <div className="availability-item__buttons">
        {!disabledEdit && (
          <ColorIconButton
            iconType="EDIT"
            edge="end"
            aria-label="edit"
            className="edit-button"
            onClick={() => {
              onEdit?.();
            }}
          />
        )}

        {!disabledRemove && (
          <ColorIconButton
            iconType="DELETE"
            edge="end"
            aria-label="delete"
            onClick={() => onArchiveClickEvent()}
          />
        )}
      </div>
    </div>
  );
};
